import { IOption } from 'common/ui/interfaces/selectors';
import { EndorsementEnum } from '../enums/endorsement.enum';

export const EndorsementLabel = {
  [EndorsementEnum.T]: 'T',
  [EndorsementEnum.H]: 'H',
  [EndorsementEnum.P]: 'P',
  [EndorsementEnum.N]: 'N',
  [EndorsementEnum.X]: 'X',
  [EndorsementEnum.TWIC]: 'TWIC',
  [EndorsementEnum.OTHER]: 'Other',
};

export const EndorsementOptions: IOption[] = Object.entries(
  EndorsementLabel
).map(([value, label]: [string, string]) => ({ value, label }));
